module.exports = __webpack_public_path__ + "static/media/sketching3.d0082d36.jpg";